module.exports = __webpack_public_path__ + "img/scientific-analysis-empty-state.f8d7884a.png";